import React from 'react'
import {Link} from "react-router-dom"
import {MoneyNav} from "../elements/MoneyNav"
import {getGlobalMoneyObject, setGlobalMoneyObject} from "../functions"
import {LoaderClass} from "../elements/LoaderClass"

export class MainMoneyClass extends React.Component {

    render() {

        const {lang, money} = this.props

        if (money) {
            if (!getGlobalMoneyObject()) {
                setGlobalMoneyObject(money)
            }
        } else {
            return (
                <>
                    <LoaderClass/>
                </>
            )
        }
        const yearsMainPage = getGlobalMoneyObject().yearsArr
        const currency = money['settings']['currencies'][money['settings']['currency']]

        return (
            <>
                <div className={`mt-2 col col-12 col-xl-9 m-auto`}>
                    <MoneyNav dataNav={undefined}/>
                    <div className={"container m-auto w-100"}>

                        {yearsMainPage.map((year, index) => {
                            const m = {
                                yearName: year['yearName'],
                                income: year['incomesTotal'],
                                expense: year['expensesTotal'],
                                preExpense: year['preExpense'],
                                balance: year['balance']
                            }
                            return (
                                <div className={"moneyMain m-auto"} key={index}>
                                    <Link to={`/${lang.lang}/money/year?year=${m.yearName}&calculation=purchase_date`}
                                          className={"text-decoration-none"}>
                                        <div className={"card mb-2"}>
                                            <div className={"card-body"}>
                                                <h5 className={"card-title border-bottom mb-3 pb-1"}>{m.yearName}</h5>
                                                <div className={"d-flex m-0"}>
                                                    <div
                                                        className={"p-1 w-100"}>{lang.body.moneyPage.main.totalIncome}</div>
                                                    <div className={"p-1 flex-shrink-1"}>
                                                        <strong className={"m-0 text-success"}>{m.income}</strong>
                                                        <strong
                                                            className={"m-0 text-success"}>&nbsp;{currency}</strong>
                                                    </div>
                                                </div>
                                                <div className={"d-flex m-0"}>
                                                    <div
                                                        className={"p-1 w-100"}>{lang.body.moneyPage.main.currentExpense}</div>
                                                    <div className={"p-1 flex-shrink-1"}>
                                                        <strong className={"m-0 text-danger"}>{m.expense}</strong>
                                                        <strong
                                                            className={"m-0 text-danger"}>&nbsp;{currency}</strong>
                                                    </div>
                                                </div>
                                                <div className={"d-flex m-0"}>
                                                    <div
                                                        className={"p-1 w-100"}>{lang.body.moneyPage.main.currentBalance}</div>
                                                    <div className={"p-1 flex-shrink-1"}>
                                                        <strong className={"m-0 text-success"}>{m.balance}</strong>
                                                        <strong
                                                            className={"m-0 text-success"}>&nbsp;{currency}</strong>
                                                    </div>
                                                </div>
                                                <div className={"d-flex m-0"}>
                                                    <div
                                                        className={"p-1 w-100"}>{lang.body.moneyPage.main.UpcomingExpense}</div>
                                                    <div className={"p-1 flex-shrink-1"}>
                                                        <strong
                                                            className={"m-0 text-danger-emphasis"}>{m.preExpense}</strong>
                                                        <strong
                                                            className={"m-0 text-danger-emphasis"}>&nbsp;{currency}</strong>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            )
                        })}

                    </div>
                </div>
            </>
        )
    }
}
